module.exports = __webpack_public_path__ + "img/MERCEDES.84478b7.jpg";